import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Paper, Typography } from "@material-ui/core";
import {
  tableCellRender,
  stringFilterOperators,
  dateFilterOperators,
  formatDateValue,
  getLatestUpdateAgro,
} from "../util/tableUtils";
import { DataGridCystellarTable } from "../util/DataGridCystellarTable";
import httpClient from "../../lib/httpClient";

export const AgrClaimsList = (props) => {
  const { t } = useTranslation();
  const policyNumber = props.policyNumber;
  const [perils, setPerils] = useState([]);
  const [perilsFetching, setPerilsFetching] = useState(false);
  const [lastUpdateDateMsg, setLastUpdateDateMsg] = useState("");

  useEffect(() => {
    getLatestUpdateAgro("/serviceLogs/agriculture?service=agricultureDb_denunce").then((lastUpdateMsg) => {
      setLastUpdateDateMsg(lastUpdateMsg);
    });
  }, []);

  useEffect(() => {
    setPerilsFetching(true);
    if (policyNumber) {
      httpClient()
        .get(`/agriculturePolicies/${policyNumber}/claims`)
        .then((res) => res.data)
        .then(async (data) => {
          setPerils(data);
          setPerilsFetching(false);
        });
    }
  }, [policyNumber]);

  const perilColumns = [
    {
      field: "complainID",
      headerName: t("agriculture.complainId"),
    },
    {
      field: "bulletinID",
      headerName: t("agriculture.bulletinId"),
    },
    {
      field: "adversityDescription",
      headerName: t("agriculture.adversity"),
    },
    {
      field: "perilName",
      headerName: t("agriculture.perilName"),
    },
    {
      field: "damageDate",
      headerName: t("agriculture.damageDate"),
      type: "date",
      sortable: false,
      filterOperators: dateFilterOperators,
      valueGetter: (params) => params.row.damageDate && formatDateValue(params.row.damageDate),
    },
  ];

  const columns = perilColumns.map((tableColumn) => ({
    valueFormatter: (params) => tableCellRender(params.value),
    filterOperators: stringFilterOperators,
    flex: 1,
    ...tableColumn,
  }));

  const goToAgriComplainPage = (row) => {
    const wnd = window.open(`#/claimsagriculture/${policyNumber}/${row.complainID}`, "_blank");

    wnd.onload = function () {
      wnd.document.title = `${row.complainID}`;
    };
  };

  return (
    <Box>
      <Paper>
        <Box p={2} pt={2}>
          <Typography
            variant={"h2"}
            style={{
              fontSize: "1.3rem",
              fontWeight: 400,
            }}
          >
            {t("agriculture.complainsTitle")}
          </Typography>
        </Box>
        <div style={{ maxHeight: "50vh", maxWidth: "100%", overflow: "auto" }}>
          <DataGridCystellarTable
            columns={columns}
            rows={perils}
            rowCount={perils.length}
            getRowId={(rowData) => rowData._id}
            onRowClick={(rowData) => goToAgriComplainPage(rowData.row)}
            pagination={false}
            loading={perilsFetching}
            customToolbarComp={lastUpdateDateMsg ? true : false}
            customToolbarCompMsg={lastUpdateDateMsg}
          />
        </div>
      </Paper>
    </Box>
  );
};
